import React, { Component } from 'react'
import Select from 'react-select'
import GlobalHelper from "../GlobalHelper.jsx";

class MultiCurrencySelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [],
            selectedOptions: this.props.value || [],
            exclude: this.props.exclude || [],
            multi: !isNaN(this.props.multi) ? this.props.multi : true,
            clearable: !isNaN(this.props.clearable) ? this.props.clearable : true,
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOptions: selectedOption
        }, () => {
            if(selectedOption){
                if (this.state.multi === true) {
                    this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
                } else {
                    this.onChange(selectedOption.value, selectedOption.label)
                }
            }else{
                this.onChange("","")
            }
        });
    }

    loadCurrencies() {
        this.setState({
            options: GlobalHelper.getSupportedCurrencies().filter(currency => !this.state.exclude.includes(currency)).map(currency => {
                return {
                    value: currency,
                    label: currency
                }
            }),
        })
    }

    componentDidMount() {
        this.loadCurrencies()
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOptions) {
            this.setState({
                selectedOptions: (Array.isArray(nextProps.value)) ? (nextProps.value.filter(option => option !== nextProps.exclude) || [])
                    : (nextProps.value || 'USD'),
                exclude: nextProps.exclude || []
            }, () => {
                this.loadCurrencies()
            })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                multi={this.state.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOptions}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={this.state.clearable}
            />
        )
    }
}

export default MultiCurrencySelect





// WEBPACK FOOTER //
// ./src/common/currency/multiselect.component.jsx